import { InjectionToken, Signal } from '@angular/core';

/**
 * Seam DI pour que `core/navigation` lise la complétude de l'espace sans
 * importer `pages/apps/getting-started` (inversion de couche interdite par
 * `scripts/check-layer-boundaries.js`). Même patron qu'`AGENCY_REACH` :
 * implémenté par `WorkspaceSetupService`, câblé dans `app.config` en
 * `useExisting`.
 */
export interface WorkspaceSetupProgress {
  /** 0-100, arrondi. */
  readonly percentage: Signal<number>;
  /** Vrai tant que le chiffre ne peut pas être calculé honnêtement. */
  readonly loading: Signal<boolean>;
  /** Branche les lectures Firestore dont le chiffre dépend. Idempotent. */
  activate(): void;
}

export const WORKSPACE_SETUP_PROGRESS = new InjectionToken<WorkspaceSetupProgress>(
  'WORKSPACE_SETUP_PROGRESS'
);
